export default __webpack_public_path__ + "static/media/009-key.cbdac3a1.png";